import { useFormContext } from "react-hook-form";
import PinVerification from "../../../components/pin-verification/pin-verification";

const EmailVerification = () => {
  const { watch } = useFormContext();
  const formValues = watch();

  return (
    <PinVerification
      title={"Email Verification"}
      description={
        <>
          Please enter the 6 digit code we have sent to your{" "}
          <strong>{formValues?.email}</strong>.
        </>
      }
      verificationType="email"
      number={formValues?.mobile}
      email={formValues?.email}
    />
  );
};

export default EmailVerification;
